module.exports = __webpack_public_path__ + "img/fwhQRcode.51004919.png";